import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Allows access for:
 *  - Consumer + AuctionAccess
 *  - Supplier + AuctionAccess
 *  - Admin
 *  - SuperAdmin
 */
export const buyContractAccessGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.getCurrentUser();

  if (!user) {
    router.navigate(['/login']);
    return false;
  }

  const isAdminOrSuper = authService.hasAnyRole('Admin', 'SuperAdmin');
  const hasAccessWithRole =
    authService.hasRole('AuctionAccess') && authService.hasAnyRole('Consumer', 'Supplier');

  if (!isAdminOrSuper && !hasAccessWithRole) {
    router.navigate(['/dashboard']);
    return false;
  }

  return true;
};
